import ParameterErrors from '../errors/ParameterErrors';
const  {throwNotProvided, throwNotOfType} = ParameterErrors;
export default class Favourite{
	constructor(props){
		const {payload, description, hash, sortValue, imageUrl, onClick, onRemove}=props;
		if(!description)throwNotProvided('description');
		if(hash===undefined||hash===null)throwNotProvided('hash');
		if(sortValue===undefined||sortValue===null)throwNotProvided('sortValue');
		this._description = description;
		this._onClick = onClick;
		this._onRemove = onRemove;
		this._payload = payload;
		this._hash = hash;
		this._imageUrl = imageUrl;
		this._sortValue = sortValue;
	}
	get payload(){
		return this._payload;
	}
	get hash(){
		return this._hash;
	}
	get sortValue(){
		return this._sortValue;
	}
	get description(){
		return this._description;
	}
	get imageUrl(){
		return this._imageUrl;
	}
	onClick(){
		this._onClick&&this._onClick();
	}
	get onRemove(){
		return this._onRemove;
	}
}
